import scoreData from './../scoreData'

class Scores {
  constructor () {
    this.total = 0
    this.progress = 0
    this.right = 0
    this.wrong = 0
    this.score = 0
    this.answers = {}
    this.sections = {}
    this.scoreData = scoreData

    this.retrieveAnswers()

    // then bind it to a modal window!
    this.bindButtonEvents()
  }

  retrieveAnswers () {
    if (this.getCookie('answers')) {
      this.answers = JSON.parse(this.getCookie('answers'))
    }

    this.setProgress()
  }

  bindButtonEvents () {
    document.body.addEventListener('click', (e) => {
      let item = e.target
      if (item.classList.contains('quiz__button')) {
        e.preventDefault()
        this.processAnswer(item)
      }
    })
  }

  setProgress () {
    this.right = 0
    this.wrong = 0
    this.score = 0
    this.total = 0
    this.progress = 0
    this.sections = {}

    if (!this.scoreData) {
      return
    }

    for (const page in this.scoreData) {
      for (const modal in this.scoreData[page]) {
        this.total++

        if (!this.sections[page]) {
          this.sections[page] = {progress: 0, right: 0, total: 0}
        }

        this.sections[page].total++
        if (this.getAnswer(page, modal)) {
          this.progress++
          this.sections[page].progress++
          if (this.checkAnswer(page, modal)) {
            this.right++
            this.sections[page].right++
          } else {
            this.wrong++
          }
        }
      }
    }

    if (this.right === 0) {
      this.score = 0
    } else {
      this.score = Math.round((this.right / this.progress) * 100)
    }

    /** Debug **/
    // console.log(this.score)
    // console.log(this.progress + ' / ' + this.total)
    // console.log(this.sections)
  }

  getLetter (id) {
    let letters = ['A', 'B', 'C', 'D', 'E', 'F']
    return (letters[id]) ? letters[id] : 'U'
  }

  processAnswer (item) {
    let optId = parseInt(item.dataset.id)
    let page = item.dataset.page
    let modal = item.dataset.modal

    let question = this.scoreData[page][modal]
    if (question === undefined) {
      alert('There was an unexpected issue\nplease reload the page and try again.')
      return
    }

    this.setAnswer(page, modal, optId)
    this.updateAnswer(page, modal, item)
    this.setProgress()
  }

  setAnswer (page, modal, optId) {
    if (this.answers[page] === undefined) {
      this.answers[page] = {}
    }
    if (this.answers[page][modal] === undefined) {
      this.answers[page][modal] = {}
    }
    this.answers[page][modal] = parseInt(optId)
    this.setCookie('answers', JSON.stringify(this.answers), 1)
  }

  getAnswer (page, modal) {
    return (this.answers[page] && this.answers[page][modal]) ? this.answers[page][modal] : null
  }

  checkAnswer (page, modal) {
    let question = this.scoreData[page][modal]
    let answer = this.getAnswer(page, modal)
    return ((question.correct + 1) === answer)
  }

  updateAnswer (page, modal, item) {
    // Stop if not answered
    let answer = this.getAnswer(page, modal)
    if (!answer) {
      return
    }

    // Check we have an 'item'
    if (!item) {
      item = document.querySelector('.' + modal + ' button[data-id="' + answer + '"')
    }

    let parent = item.parentElement
    let container = item.closest('.quiz')
    let trigger = document.querySelector('.modal__button--quiz.modal__button--' + modal)

    // Check answer
    if (this.checkAnswer(page, modal)) {
      // alert('Correct!')
      parent.classList.add('quiz__item--correct')
      container.classList.add('quiz--correct')
      trigger.classList.add('modal__button--correct')
    } else {
      // alert('Wrong!')
      parent.classList.add('quiz__item--wrong')
      container.classList.add('quiz--wrong')
      trigger.classList.add('modal__button--wrong')
    }

    let options = container.querySelectorAll('.quiz__item')
    for (const opt of options) {
      opt.querySelector('.quiz__button').setAttribute('disabled', true)
    }
  }

  clearAnswers () {
    this.eraseCookie('answers')
  }

  setCookie (name, value, days) {
    let expires = ''
    if (days) {
      let date = new Date()
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
      expires = '; expires=' + date.toUTCString()
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/'
  }

  getCookie (name) {
    let nameEQ = name + '='
    let ca = document.cookie.split(';')
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i]
      while (c.charAt(0) === ' ') c = c.substring(1, c.length)
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
    }
    return null
  }

  eraseCookie (name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
  }
}

export { Scores }



// WEBPACK FOOTER //
// ./src/classes/Scores.js